export default __webpack_public_path__ + "static/media/daynight_yellow.34a927a3.png";